/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400 }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    index: {
      value: "I",
      bg: true,
    },
    id: {
      value: null,
      bg: true,
    },
    arisingNumber: {
      value: null,
      bg: true,
    },
    cumulativeNumber: {
      value: null,
      bg: true,
    },
    title: {
      value: "Doanh thu từ hoạt động đại lý xổ số",
      bg: true,
    },
  },
  {
    bold: false,
    index: {
      value: "1",
      bg: false,
    },
    id: {
      value: 13,
      bg: false,
    },
    arisingNumber: {
      value: 0,
      bg: false,
    },
    cumulativeNumber: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng doanh thu trả trong kỳ",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "2",
      bg: false,
    },
    id: {
      value: 14,
      bg: false,
    },
    arisingNumber: {
      value: 0,
      bg: false,
    },
    cumulativeNumber: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng doanh thu thuộc diện khấu trừ thuế",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "3",
      bg: true,
    },
    id: {
      value: 15,
      bg: true,
    },
    arisingNumber: {
      value: 0,
      bg: true,
    },
    cumulativeNumber: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng số thuế TNCN phát sinh",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "4",
      bg: true,
    },
    id: {
      value: 16,
      bg: true,
    },
    arisingNumber: {
      value: 0,
      bg: true,
    },
    cumulativeNumber: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng số thuế TNCN đã khấu trừ",
      bg: false,
    },
  },
  {
    onlyTitle: true,
    bold: true,
    index: {
      value: "II",
      bg: true,
    },
    id: {
      value: null,
      bg: true,
    },
    arisingNumber: {
      value: null,
      bg: true,
    },
    cumulativeNumber: {
      value: null,
      bg: true,
    },
    title: {
      value: "Doanh thu từ hoạt động đại lý bảo hiểm",
      bg: true,
    },
  },
  {
    bold: false,
    index: {
      value: "1",
      bg: false,
    },
    id: {
      value: 17,
      bg: false,
    },
    arisingNumber: {
      value: 0,
      bg: false,
    },
    cumulativeNumber: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng doanh thu trả trong kỳ",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "2",
      bg: false,
    },
    id: {
      value: 18,
      bg: false,
    },
    arisingNumber: {
      value: 0,
      bg: false,
    },
    cumulativeNumber: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng doanh thu thuộc diện khấu trừ thuế",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "3",
      bg: true,
    },
    id: {
      value: 19,
      bg: true,
    },
    arisingNumber: {
      value: 0,
      bg: true,
    },
    cumulativeNumber: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng số thuế TNCN phát sinh",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "4",
      bg: true,
    },
    id: {
      value: 20,
      bg: true,
    },
    arisingNumber: {
      value: 0,
      bg: true,
    },
    cumulativeNumber: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng số thuế TNCN đã khấu trừ",
      bg: false,
    },
  },
  {
    onlyTitle: true,
    bold: true,
    index: {
      value: "III",
      bg: true,
    },
    id: {
      value: null,
      bg: true,
    },
    arisingNumber: {
      value: null,
      bg: true,
    },
    cumulativeNumber: {
      value: null,
      bg: true,
    },
    title: {
      value: "Thu nhập từ tiền phí tích lũy bảo hiểm nhân thọ, bảo hiểm không bắt buộc khác",
      bg: true,
    },
  },
  {
    bold: false,
    index: {
      value: "1",
      bg: false,
    },
    id: {
      value: 21,
      bg: false,
    },
    arisingNumber: {
      value: 0,
      bg: false,
    },
    cumulativeNumber: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng thu nhập trả thuộc diện khấu trừ",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "2",
      bg: true,
    },
    id: {
      value: 22,
      bg: true,
    },
    arisingNumber: {
      value: 0,
      bg: true,
    },
    cumulativeNumber: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng số thuế TNCN phát sinh",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "3",
      bg: true,
    },
    id: {
      value: 23,
      bg: true,
    },
    arisingNumber: {
      value: 0,
      bg: true,
    },
    cumulativeNumber: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng số thuế TNCN đã khấu trừ",
      bg: false,
    },
  },
  {
    onlyTitle: true,
    bold: true,
    index: {
      value: "IV",
      bg: true,
    },
    id: {
      value: null,
      bg: true,
    },
    arisingNumber: {
      value: null,
      bg: true,
    },
    cumulativeNumber: {
      value: null,
      bg: true,
    },
    title: {
      value: "Doanh thu từ hoạt động bán hàng đa cấp",
      bg: true,
    },
  },
  {
    bold: false,
    index: {
      value: "1",
      bg: false,
    },
    id: {
      value: 24,
      bg: false,
    },
    arisingNumber: {
      value: 0,
      bg: false,
    },
    cumulativeNumber: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng doanh thu trả trong kỳ",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "2",
      bg: false,
    },
    id: {
      value: 25,
      bg: false,
    },
    arisingNumber: {
      value: 0,
      bg: false,
    },
    cumulativeNumber: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng doanh thu thuộc diện khấu trừ thuế",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "3",
      bg: true,
    },
    id: {
      value: 26,
      bg: true,
    },
    arisingNumber: {
      value: 0,
      bg: true,
    },
    cumulativeNumber: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng số thuế TNCN phát sinh",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "4",
      bg: true,
    },
    id: {
      value: 27,
      bg: true,
    },
    arisingNumber: {
      value: 0,
      bg: true,
    },
    cumulativeNumber: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Tổng số thuế TNCN đã khấu trừ",
      bg: false,
    },
  },
  {
    bold: true,
    index: {
      value: "V",
      bg: true,
    },
    id: {
      value: 28,
      bg: true,
    },
    arisingNumber: {
      value: 0,
      bg: true,
    },
    cumulativeNumber: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Tổng số thuế TNCN đã khấu trừ [28]=[16]+[20]+[23]+[27]",
      bg: true,
    },
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>STT</Th>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Mã chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Số phát sinh trong kỳ</Th>
              <Th style={{ textAlign: "center" }}>Số lũy kế</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.index.value + index}>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.index.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.index.value}
                  </Td>
                  <Td
                    row={row}
                    colSpan={row.onlyTitle ? 4 : 1}
                    style={{
                      textAlign: "left",
                      background: !row.index.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.title.value}
                  </Td>
                  {!row.onlyTitle && (
                    <>
                      <Td
                        row={row}
                        style={{
                          textAlign: "center",
                          background: !row.id.bg ? "transparent" : "#ddeff3",
                        }}
                      >
                        {row.id.value}
                      </Td>
                      <Td
                        row={row}
                        style={{
                          textAlign: "right",
                          background: !row.arisingNumber.bg ? "transparent" : "#ddeff3",
                        }}
                      >
                        {row.arisingNumber.bg ? (
                          row.arisingNumber.value
                        ) : (
                          <InputTable
                            id={row.id.value}
                            name="arisingNumber"
                            value={row.arisingNumber.value}
                            onChange={handleChange}
                          />
                        )}
                      </Td>
                      <Td
                        row={row}
                        style={{
                          textAlign: "right",
                          background: !row.cumulativeNumber.bg ? "transparent" : "#ddeff3",
                        }}
                      >
                        {row.cumulativeNumber.bg ? (
                          row.cumulativeNumber.value
                        ) : (
                          <InputTable
                            id={row.id.value}
                            name="cumulativeNumber"
                            value={row.cumulativeNumber.value}
                            onChange={handleChange}
                          />
                        )}
                      </Td>
                    </>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
